/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { getUsers } from "../../lib/user";
import { toast } from "react-toastify";
import CountrySelectInput from "../shared/countrySelectInput";
import { generatePDF } from "../shared/pdf/generatePDF";
import { AmountFormat } from "../../lib/helper/amountFormat";
import InsuranceCheckbox from "./helperComponent/insuranceCheckBox";
import CIFValue from "./helperComponent/CIFValue";
import ValidityDate from "./helperComponent/validityDate";
import ServiceTemp from "./servicesTemp/tempAdminEstimate";
import { Select, Spin, message } from "antd";
import TransportationMode from "./TransportationMode";
import { validateFormData } from "./helperComponent/Funtions";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import CustomButton from "../shared/common/customButton";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../../config/api";
import DiscountInput from "./helperComponent/DiscountInput";

const AddQuotesForExistUser = ({ settingsData }) => {
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [totalWeight, setTotalWeight] = useState(0);
  const [creationDate, setCreationDate] = useState(new Date()); // Initialize with the current date
  const [validationErrors, setValidationErrors] = useState({});
  const [quotationCreatedByAdmin, setQuotationCreatedByAdmin] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showCurrencyWarning, setShowCurrencyWarning] = useState(false);
  const [currencyWarningMessage, setCurrencyWarningMessage] = useState("");
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");

  // Function to calculate the default validity date (current date + 10 days)
  const getDefaultValidityDate = () => {
    const creationDate = new Date();
    creationDate.setDate(creationDate.getDate() + 10);
    return creationDate.toISOString().split("T")[0]; // Get the date part only
  };

  const initialFormData = {
    status: "pending",
    sendStatus: true,
    quoteNumber: "",
    validityDate: getDefaultValidityDate() || "",
    name: "",
    userId: "",
    email: "",
    postalCode: "",
    city: "",
    address: "",
    country: "",
    loadAddress: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    unloadAddress: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    unloadAddress_CompanyName: "",
    modeOfTransfer: "By Road",
    cargoValue: { value: "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: 0,
    description: "",
    creationDate: new Date().toISOString(),
    services: [
      {
        numberOfItem: "",
        description: "",
        exclVAT: "",
      },
    ],
    total: 0,
    subTotal: 0,
    vatPercentage: "",
    vatAmount: 0,
    insurance: 0,
    currency: "USD",
    quoteCreatedDate: new Date().toISOString(),
    // Add these new fields
    loadState: "",
    unloadState: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [Total, setTotal] = useState(0);

  const validateMandatoryFields = () => {
    const mandatoryFields = [
      "loadCountry",
      "unloadCountry",
      "description",
      "pcsPackage",
      "name",
    ];
    for (let field of mandatoryFields) {
      if (
        !formData[field] ||
        (typeof formData[field] === "string" && formData[field].trim() === "")
      ) {
        return false;
      }
    }
    // return true;
    if (formData.pcsPackage.length === 0) {
      return false;
    }

    for (let pkg of formData.pcsPackage) {
      // Rename 'package' to 'pkg' or another suitable name
      if (
        !pkg.quantity ||
        !pkg.weight.value ||
        !pkg.length.value ||
        !pkg.width.value ||
        !pkg.height.value
      ) {
        return false;
      }
    }

    return true;
  };

  const { data, isLoading, error } = useQuery(
    ["customers"],
    async () => {
      try {
        // This will correctly fetch only users with role="user" from your util function
        const res = await getUsers();
        return res || [];
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Failed to load customers. Please try refreshing the page.");
        throw error;
      }
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 0, // Force fresh data on component mount
      refetchOnMount: true // Always refetch when component mounts
    }
  );

  // Update quote number when settingsData becomes available
  useEffect(() => {
    if (settingsData?.quoteNumber_Prefix) {
      setFormData(prevData => ({
        ...prevData,
        quoteNumber: settingsData.quoteNumber_Prefix
      }));
    }
  }, [settingsData]);

  // Check currency compatibility and show warning
  const checkCurrencyCompatibility = () => {
    if (!selectedCustomer || !formData.cargoValue.currency || !formData.cifValue.currency || !formData.currency) {
      return;
    }

    const customerCurrency = selectedCustomer.currency;
    const cargoCurrency = formData.cargoValue.currency;
    const cifCurrency = formData.cifValue.currency;
    const templateCurrency = formData.currency;

    if (!customerCurrency) {
      setShowInfoMessage(true);
      setShowCurrencyWarning(false);
      return;
    }

    const currencies = [customerCurrency, cargoCurrency, cifCurrency, templateCurrency];
    const uniqueCurrencies = [...new Set(currencies)];

    if (uniqueCurrencies.length > 1) {
      const changedAreas = [];
      if (cargoCurrency !== customerCurrency) changedAreas.push("Cargo Value");
      if (cifCurrency !== customerCurrency) changedAreas.push("CIF Value");
      if (templateCurrency !== customerCurrency) changedAreas.push("Template");

      const message = `⚠️ Currency Mismatch Alert: Selected customer "${selectedCustomer.name}" has ${customerCurrency} currency, but you've changed the currency in ${changedAreas.join(", ")}. All currencies must match to access Calculate Estimate. Please align all currencies or fill services manually.`;

      setCurrencyWarningMessage(message);
      setShowCurrencyWarning(true);
      setShowInfoMessage(false);
    } else {
      setShowCurrencyWarning(false);
      setShowInfoMessage(false);
    }
  };

  // Update selectedCustomer when the user is selected
  const handleExistUsers = (e) => {
    const userId = e;
    const user = data.find((user) => user.id === userId);
    setSelectedCustomer(user);
  };

  // Update form data when selectedCustomer changes
  useEffect(() => {
    if (selectedCustomer) {
      const customerCurrency = selectedCustomer.currency || "USD";

      setFormData((prevFormData) => ({
        ...prevFormData,
        name: selectedCustomer.name || "",
        userId: selectedCustomer.id || "",
        email: selectedCustomer.email || "",
        postalCode: selectedCustomer.postalCode || "",
        address: selectedCustomer.address || "",
        city: selectedCustomer.city || "",
        country: selectedCustomer.country || "",
        // Set all currencies to match customer currency if customer has currency
        cargoValue: {
          ...prevFormData.cargoValue,
          currency: customerCurrency
        },
        cifValue: {
          ...prevFormData.cifValue,
          currency: customerCurrency
        },
        currency: customerCurrency
      }));
    }
  }, [selectedCustomer]);

  // Check currency compatibility whenever relevant values change
  useEffect(() => {
    checkCurrencyCompatibility();
  }, [selectedCustomer, formData.cargoValue.currency, formData.cifValue.currency, formData.currency]);

  useEffect(() => {
    // Calculate Sub Total and separate discountable base services
    let subTotal = 0;
    let discountableSubTotal = 0;

    formData.services.forEach((service) => {
      const totalForService =
        parseFloat(service.numberOfItem || 1) *
        parseFloat(service.exclVAT || 0);
      subTotal += totalForService;

      const desc = (service.description || "").trim().toLowerCase();
      const isTaxOrDuty =
        desc === "vat" ||
        desc.includes("duty") ||
        desc.includes("duties") ||
        desc.includes("tax");

      if (!isTaxOrDuty) {
        discountableSubTotal += totalForService;
      }
    });

    // Calculate Discount — applies only to base services subtotal, excluding VAT/Duties/Taxes
    const rawDiscount = parseFloat(discountValue) || 0;
    let discountAmount = 0;
    if (rawDiscount > 0) {
      if (discountType === "percentage") {
        discountAmount = (discountableSubTotal * rawDiscount) / 100;
      } else {
        discountAmount = rawDiscount;
      }
      // Clamp so discount never exceeds discountableSubTotal
      discountAmount = Math.min(discountAmount, discountableSubTotal);
    }
    const discountedSubTotal = subTotal - discountAmount;

    // Calculate VAT Amount (calculated on base subtotal, NOT discounted)
    const vatPercentage = parseFloat(formData.vatPercentage || 0);
    const vatAmount =
      vatPercentage === 0 ? 0 : (subTotal * vatPercentage) / 100;

    // Calculate Total including VAT
    let total = discountedSubTotal + vatAmount;

    // Calculate InsuranceTotal including insurance
    let InsuranceTotal = total;
    const insuranceValue = parseFloat(formData.insurance || 0);
    if (insuranceValue !== 0) {
      InsuranceTotal += insuranceValue;
    }

    // Format total to display only two decimal points
    const formattedTotal = InsuranceTotal.toFixed(2);

    // Discount metadata
    const discountData = discountAmount > 0
      ? {
          type: discountType,
          value: rawDiscount,
          amount: parseFloat(discountAmount.toFixed(2)),
          servicesSubtotalBeforeDiscount: discountableSubTotal,
        }
      : null;

    // Update state
    setTotal(formattedTotal);
    setFormData((prevData) => ({
      ...prevData,
      subTotal: subTotal.toFixed(2), // Update subTotal
      vatAmount: vatAmount.toFixed(2), // Update vatAmount
      total: formattedTotal, // Update total
      discount: discountData,
    }));
  }, [formData.services, formData.vatPercentage, formData.insurance, discountType, discountValue]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "vatPercentage") {
      // Match Add Quote From Request: optional, >= 0, store numeric to avoid leading zeros
      const numValue = value === "" ? "" : parseFloat(value);
      if (value === "" || (!isNaN(numValue) && numValue >= 0)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value === "" ? "" : numValue,
        }));
        setValidationErrors((prev) => ({ ...prev, vatPercentage: false }));
      } else {
        setValidationErrors((prev) => ({ ...prev, vatPercentage: true }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handlePcsOfPkgInput = (index, field, e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      // Ensure that pcsPackage array has an item at the specified index
      if (pcsPackage[index]) {
        // Update the specific nested property (quantity, weight, length, width, height)
        if (field === "quantity") {
          pcsPackage[index][field] = value;
        } else {
          pcsPackage[index][field].value = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === "weight") {
          // Update only the weight unit
          pcsPackage[index].weight.unit = value;
        } else {
          // Update length, width, and height units together
          pcsPackage[index].length.unit = value;
          pcsPackage[index].width.unit = value;
          pcsPackage[index].height.unit = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };

  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };
  const validateQuoteFormData = (formData) => {
    const errors = [];
    const invalidFields = [];

    const requiredFields = [
      "name",
      "email",
      "loadCountry",
      "loadCity",
      "unloadCity",
      "unloadCountry",
      "description",
      "loadPostalCode",
      "unloadAddress",
      "unloadPostalCode",
      "cargoValue",
      "cifValue",
    ];

    requiredFields.forEach((field) => {
      if (field === "cargoValue" || field === "cifValue") {
        if (!formData[field].value || formData[field].value.trim() === "") {
          errors.push(`${field} is required and cannot be empty`);
          invalidFields.push(field);
        }
      } else if (!formData[field] || formData[field].trim() === "") {
        errors.push(`${field} is required and cannot be empty`);
        invalidFields.push(field);
      }
    });
    // VAT is optional; only flag when negative
    if (formData.vatPercentage !== "" && formData.vatPercentage < 0) {
      errors.push("VAT Percentage must be greater than or equal to 0");
      invalidFields.push("vatPercentage");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      errors.push("Invalid email format");
      invalidFields.push("email");
    }

    if (formData.pcsPackage.length === 0) {
      errors.push("At least one package is required");
      invalidFields.push("pcsPackage");
    } else {
      let isPackageComplete = false;
      formData.pcsPackage.forEach((pkg, index) => {
        if (
          pkg.quantity &&
          pkg.weight.value &&
          pkg.length.value &&
          pkg.width.value &&
          pkg.height.value
        ) {
          isPackageComplete = true;
        } else {
          invalidFields.push(
            `quantity-${index}`,
            `weight-${index}`,
            `length-${index}`,
            `width-${index}`,
            `height-${index}`
          );
        }
      });
      if (!isPackageComplete) {
        errors.push("At least one package must have all details filled");
      }
    }

    if (!formData.quoteNumber || formData.quoteNumber.trim() === "") {
      errors.push("Quote Number is required");
      invalidFields.push("quoteNumber");
    }

    if (
      !formData.cargoValue.value ||
      parseFloat(formData.cargoValue.value) <= 0
    ) {
      errors.push("Cargo Value must be a positive number");
      invalidFields.push("cargoValue");
    }

    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      errors.push("CIF Value must be a positive number");
      invalidFields.push("cifValue");
    }

    return { errors, invalidFields };
  };

  const handleAddData = async (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    setQuotationCreatedByAdmin(true);
    const { errors, invalidFields } = validateQuoteFormData(formData);
    if (errors.length > 0) {
      errors.forEach((error) => toast.error(error));
      highlightInvalidFields(invalidFields);
      return;
    }

    // if (!templateSelected) {
    //   toast.error("Please select a template before updating.");
    //   return;
    // }

    try {
      setLoading(true);
      const serviceErrors = {};
      formData.services.forEach((service, index) => {
        if (!service.numberOfItem || parseFloat(service.numberOfItem) <= 0) {
          serviceErrors[`service_${index}_numberOfItem`] = true;
        }
        if (!service.description || service.description.trim() === "") {
          serviceErrors[`service_${index}_description`] = true;
        }
        // if (!service.exclVAT || parseFloat(service.exclVAT) <= 0) {
        //   serviceErrors[`service_${index}_exclVAT`] = true;
        // }
      });

      // if (Object.keys(serviceErrors).length > 0) {
      //   setValidationErrors((prev) => ({ ...prev, ...serviceErrors }));
      //   toast.error(
      //     "Please fill in all required fields in the services section."
      //   );
      //   return;
      // }


      const createRes = await api.post("/firestore/quotes/create-with-quote-number", {
        ...formData,
        vatPercentage: isNaN(parseFloat(formData.vatPercentage || 0))
          ? 0
          : parseFloat(formData.vatPercentage || 0),
        quoteCreatedDate: new Date().toISOString(),
      });
      const savedQuoteNumber = createRes?.data?.quoteNumber;
      if (!savedQuoteNumber) {
        throw new Error("Failed to assign quote number");
      }

      // Send notification to the client
      await api.post("/notifications", {
        title: "New Quote Created by Admin",
        message: `A new quote (${savedQuoteNumber}) has been created for you by the admin. Please review and approve it.`,
        linkText: "View Quote",
        link: `/newquotes`,
        role: "user",
        userId: formData.userId,
        quoteNumber: savedQuoteNumber,
        type: "quotes-from-admin"
      });

      setAttemptedSubmit(false);
      toast.success("Quotes data saved successfully!");
      window.location.reload();

    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const highlightInvalidFields = (invalidFields) => {
    invalidFields.forEach((field) => {
      const element = document.getElementById(field);
      if (element) {
        element.style.border = "2px solid red";
      }
    });

    // Remove highlight after 3 seconds
    setTimeout(() => {
      invalidFields.forEach((field) => {
        const element = document.getElementById(field);
        if (element) {
          element.style.border = "";
        }
      });
    }, 3000);
  };

  // const handleAddData = async (e) => {
  //   e.preventDefault();
  //   const errors = validateFormData(formData, ["unloadCountry", "loadCountry"]);
  //   if (Object.keys(errors).length > 0) {
  //     Object.values(errors).forEach((errorMessage) => {
  //       message.error(errorMessage);
  //     });
  //   } else {
  //     try {
  //       setLoading(true);
  //       const quotesRef = collection(db, "quotes");
  //       const querySnapshot = await getDocs(quotesRef);
  //       if (querySnapshot.empty) {
  //         throw new Error("No quotes found with the specified role");
  //       }
  //       const quotesData = querySnapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));

  //       const nextNumber = getNextQuoteNumber(quotesData, settingsData);
  //       if (
  //         nextNumber.localeCompare(formData.quoteNumber) == 0 ||
  //         nextNumber.localeCompare(formData.quoteNumber) < 0
  //       ) {
  //         // setFormData((prevFormData) => ({
  //         //   ...prevFormData,
  //         //   quoteNumber: nextNumber,
  //         // }));
  //         // formData.quoteNumber = nextNumber;
  //         const usersCollection = collection(db, "quotes");
  //         await addDoc(usersCollection, formData);
  //         toast.success("Quotes data saved successfully!");
  //         window.location.reload();
  //         // Consider resetting form or redirecting instead of reloading
  //         // setUserData({ name: '', email: '', password: '' });
  //       } else {
  //         setShowError(true);
  //         setNewNumber(nextNumber);
  //       }
  //     } catch (error) {
  //       console.error("Error saving data:", error);
  //       toast.error("Error saving data. Please try again later.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleDraft = async (e) => {
    e.preventDefault();
    setQuotationCreatedByAdmin(true);
    const { errors, invalidFields } = validateQuoteFormData(formData);
    if (errors.length > 0) {
      errors.forEach((error) => toast.error(error));
      highlightInvalidFields(invalidFields);
      return;
    }

    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((errorMessage) => {
        message.error(errorMessage);
      });
    } else {
      setLoading1(true);
      try {
        const updatedData = {
          ...formData,
          sendStatus: false,
          quoteCreatedDate: new Date().toISOString(),
        };

        const createRes = await api.post("/firestore/quotes/create-with-quote-number", updatedData);
        const savedQuoteNumber = createRes?.data?.quoteNumber;
        if (!savedQuoteNumber) {
          throw new Error("Failed to assign quote number");
        }

        navigate("/quoteadmin");
        setAttemptedSubmit(false);
        toast.success("Quotes data saved successfully!");
        queryClient.invalidateQueries(["quotes"]); // Refresh the quotes list
        window.location.reload();

      } catch (error) {
        console.error("Error saving data:", error);
        toast.error("Error saving data. Please try again later.");
      } finally {
        setLoading1(false);
      }
    }
  };

  const downloadPDF = async () => {
    setQuotationCreatedByAdmin(true);
    // const validationErrors = validateQuoteFormData(formData);
    const { errors, invalidFields } = validateQuoteFormData(formData);
    // if (validationErrors.length > 0) {
    //   validationErrors.forEach(error => toast.error(error));
    //   return;
    // }

    if (errors.length > 0) {
      toast.error("Please fill all required fields");
      highlightInvalidFields(invalidFields);
      return;
    }

    setPdfLoading(true);

    try {
      const blob = await generatePDF(formData, quotationCreatedByAdmin);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${formData.quoteNumber}.pdf`;
      link.click();
    } catch (error) {
      console.error(error);
      toast.error("Error generating PDF. Please try again later.");
    } finally {
      setPdfLoading(false);
    }
  };

  const areMandatoryFieldsFilled = () => {
    const requiredFields = [
      "quoteNumber",
      "name",
      "loadAddress",
      "loadCountry",
      "loadCity",
      "loadPostalCode",
      "unloadAddress",
      "unloadCountry",
      "unloadCity",
      "unloadPostalCode",
      "description",
    ];

    // Check all string fields
    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        return false;
      }
    }

    // Check cargoValue and cifValue
    if (!formData.cargoValue.value || formData.cargoValue.value.trim() === "") {
      return false;
    }
    if (!formData.cifValue.value || formData.cifValue.value.trim() === "") {
      return false;
    }

    // Check packages
    if (formData.pcsPackage.length === 0) {
      return false;
    }
    for (let pkg of formData.pcsPackage) {
      if (
        !pkg.quantity ||
        !pkg.weight.value ||
        !pkg.length.value ||
        !pkg.width.value ||
        !pkg.height.value
      ) {
        return false;
      }
    }

    return true;
  };

  // Check if currencies are aligned for Calculate Estimate
  const areCurrenciesAligned = () => {
    if (!selectedCustomer) return false;

    const customerCurrency = selectedCustomer.currency;
    if (!customerCurrency) return false; // No customer currency set

    return (
      customerCurrency === formData.cargoValue.currency &&
      customerCurrency === formData.cifValue.currency &&
      customerCurrency === formData.currency
    );
  };

  return (
    <div>
      {/* Currency Warning Messages */}
      {showCurrencyWarning && (
        <div className="mx-[30px] mb-4 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-700 font-medium">
                {currencyWarningMessage}
              </p>
            </div>
          </div>
        </div>
      )}

      {showInfoMessage && selectedCustomer && !selectedCustomer.currency && (
        <div className="mx-[30px] mb-4 space-y-3">
          <div className="p-4 bg-blue-50 border-l-4 border-blue-400 rounded-r-md">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-blue-700 font-medium">
                  Selected customer "{selectedCustomer.name}" has no assigned currency. You can set a currency for this customer from the Clients Tab. In the Client Table, click on Edit in the actions column, select a currency, and click the update button.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="w-full" id="data">
        <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
          <div className="flex flex-col gap-1 w-1/2  py-2">
            <label className="w-full text-sm font-normal" htmlFor="quoteNumber">
              Quote Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder=""
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="quoteNumber"
              onChange={(e) => handleInputChange(e)}
              value={formData.quoteNumber}
              name="quoteNumber"
            />
          </div>

          <ValidityDate formData={formData} setFormData={setFormData} />
        </div>
        <div className="mx-[30px] flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="customerName">
            Customer Name <span className="text-red-500">*</span>
          </label>
          <Select
            id="name"
            onChange={handleExistUsers}
            value={selectedCustomer ? selectedCustomer.id : undefined}
            name="name"
            placeholder={isLoading ? "Loading customers..." : "Select Customer"}
            options={data?.map((user) => ({
              label: `${user.name} (${user.currency || 'No Currency'})`,
              value: user.id,
              key: user.id,
            }))}
            notFoundContent={isLoading ? "Loading customers..." : "Customer not found"}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            showSearch
            loading={isLoading}
          />
        </div>

        <div className="mx-[30px] ">
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Load Address <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Street 23, new town"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="loadAddress"
              onChange={handleInputChange}
              value={formData.loadAddress}
              name="loadAddress"
            />
          </div>
        </div>
        <div className="mx-[30px] grid md:grid-cols-4 grid-cols-1 gap-3">
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Load Country <span className="text-red-500">*</span>
            </label>
            <CountrySelectInput
              label=""
              onChange={handleInputChange}
              value={formData.loadCountry}
              name="loadCountry"
              id="loadCountry"
              setFormData={setFormData}
            />
          </div>
          <div className="flex flex-col gap-1 py-2 ">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Load City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="city name"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="loadCity"
              onChange={handleInputChange}
              value={formData.loadCity}
              name="loadCity"
            />
          </div>
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Load Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Postal Code"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              name="loadPostalCode"
              id="loadPostalCode"
              onChange={handleInputChange}
              value={formData.loadPostalCode}
            />
          </div>

          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Load Company Name
            </label>
            <input
              type="text"
              placeholder="Load Company Name "
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              name="loadAddress_CompanyName"
              id="loadAddress_CompanyName"
              onChange={handleInputChange}
              value={formData.loadAddress_CompanyName}
            />
          </div>
        </div>

        <div className="mx-[30px] ">
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal " htmlFor="country">
              Unload Address <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Street 23, new town"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="unloadAddress"
              onChange={handleInputChange}
              value={formData.unloadAddress}
              name="unloadAddress"
            />
          </div>
        </div>

        <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              <span className="text-red-500">*</span>Unload country
            </label>
            <CountrySelectInput
              label=""
              onChange={handleInputChange}
              value={formData.unloadCountry}
              name="unloadCountry"
              id="unloadCountry"
            />
          </div>
          <div className="flex flex-col gap-1 py-2 ">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Unload City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="select city"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="unloadCity"
              onChange={handleInputChange}
              value={formData.unloadCity}
              name="unloadCity"
            />
          </div>
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Unload Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Postal Code"
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              name="unloadPostalCode"
              id="unloadPostalCode"
              onChange={handleInputChange}
              value={formData.unloadPostalCode}
            />
          </div>
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Unload Company Name
            </label>
            <input
              type="text"
              placeholder="unload Company Name "
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              name="unloadAddress_CompanyName"
              id="unloadAddress_CompanyName"
              onChange={handleInputChange}
              value={formData.unloadAddress_CompanyName}
            />
          </div>
        </div>

        <div className="mx-[30px]">
          <div className="flex flex-col gap-1 py-2 ">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress">
              Mode of Transport
            </label>
            <TransportationMode formData={formData} setFormData={setFormData} />
          </div>
        </div>

        <div className="mx-[30px] grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="cargoValue">
              Cargo Value <span className="text-red-500">*</span>
            </label>
            <div className="flex items-center">
              <input
                type="text"
                className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue`}
                name="cargoValue"
                id="cargoValue"
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    value === "" ||
                    (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                  ) {
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      cargoValue: {
                        ...prevFormData.cargoValue,
                        value: value,
                      },
                    }));
                  }
                }}
                value={formData.cargoValue.value || ""}
              />
              <Select
                // className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                name="cargoValue-currency"
                id="cargoValue-currency"
                onChange={(e) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    cargoValue: {
                      ...prevFormData.cargoValue,
                      currency: e,
                    },
                    cifValue: {
                      ...prevFormData.cifValue,
                      currency: e,
                    },
                  }));
                }}
                value={formData.cargoValue.currency || ""}
                options={[
                  { value: "USD", label: "USD" },
                  { value: "EUR", label: "EUR" },
                  { value: "GBP", label: "GBP" },
                ]}
                showSearch
              ></Select>
            </div>
          </div>

          <div className="flex flex-col gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="cifValue">
              CIF Value <span className="text-red-500">*</span>
            </label>
            <div className="flex items-center gap-1">
              <CIFValue formData={formData} setFormData={setFormData} />

              <Select
                // className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                name="cifValue-currency"
                id="cifValue-currency"
                onChange={(e) =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    cifValue: {
                      ...prevFormData.cifValue,
                      currency: e,
                    },
                  }))
                }
                value={formData.cifValue.currency || ""}
                options={[
                  { value: "USD", label: "USD" },
                  { value: "EUR", label: "EUR" },
                  { value: "GBP", label: "GBP" },
                ]}
                showSearch
              ></Select>
            </div>
          </div>
        </div>

        <h2 className="mx-[30px] font-bold text-xl mt-4">Goods</h2>

        {/* Render input fields based on pcsOfPkg value */}
        {formData.pcsPackage.map((formItem, index) => (
          <div
            key={index}
            className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
          >
            {/* Weight */}
            <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal"
                htmlFor={`quantity-${index}`}
              >
                Quantity<span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id={`quantity-${index}`}
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    value === "" ||
                    (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                  ) {
                    handlePcsOfPkgInput(index, "quantity", e);
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    e.key === "e" ||
                    e.key === "-" ||
                    e.key === "+" ||
                    e.key === "E"
                  ) {
                    e.preventDefault();
                  }
                }}
                min="1"
                step="1"
                value={formData.pcsPackage[index]?.quantity || ""}
              />
            </div>
            <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal"
                htmlFor={`weight-${index}`}
              >
                Weight<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <input
                  type="number"
                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`weight-${index}`}
                  id={`weight-${index}`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                    ) {
                      handlePcsOfPkgInput(index, "weight", e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "E"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="1"
                  step="1"
                  value={formData.pcsPackage[index]?.weight.value || ""}
                />
                <select
                  className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`weight-unit-${index}`}
                  id={`weight-unit-${index}`}
                  onChange={(e) => handleUnitChange(index, "weight", e)}
                  value={formData.pcsPackage[index]?.weight.unit || ""}
                >
                  <option value="kg">kg</option>
                  <option value="lbs">lbs</option>
                </select>
              </div>
            </div>

            {/* Length */}
            <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal"
                htmlFor={`length-${index}`}
              >
                Length<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <input
                  type="number"
                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`length-${index}`}
                  id={`length-${index}`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                    ) {
                      handlePcsOfPkgInput(index, "length", e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "e" || e.key === "-" || e.key === "+") {
                      e.preventDefault();
                    }
                  }}
                  min="1"
                  step="1"
                  value={formData.pcsPackage[index]?.length.value || ""}
                />
                <select
                  className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`length-unit-${index}`}
                  id={`length-unit-${index}`}
                  onChange={(e) => handleUnitChange(index, "length", e)}
                  value={formData.pcsPackage[index]?.length.unit || ""}
                >
                  <option value="cm">cm</option>
                  <option value="in">in</option>
                </select>
              </div>
            </div>
            {/* Width */}
            <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal"
                htmlFor={`width-${index}`}
              >
                Width<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <input
                  type="number"
                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`width-${index}`}
                  id={`width-${index}`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                    ) {
                      handlePcsOfPkgInput(index, "width", e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "E"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="1"
                  step="1"
                  value={formData.pcsPackage[index]?.width.value || ""}
                />
                <select
                  className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`width-unit-${index}`}
                  id={`width-unit-${index}`}
                  onChange={(e) => handleUnitChange(index, "width", e)}
                  value={formData.pcsPackage[index]?.width.unit || ""}
                >
                  <option value="cm">cm</option>
                  <option value="in">in</option>
                </select>
              </div>
            </div>
            {/* Height */}
            <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal"
                htmlFor={`height-${index}`}
              >
                Height<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center">
                <input
                  type="number"
                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`height-${index}`}
                  id={`height-${index}`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                    ) {
                      handlePcsOfPkgInput(index, "height", e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "E"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="1"
                  step="1"
                  value={formData.pcsPackage[index]?.height.value || ""}
                />
                <select
                  className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name={`height-unit-${index}`}
                  id={`height-unit-${index}`}
                  onChange={(e) => handleUnitChange(index, "height", e)}
                  value={formData.pcsPackage[index]?.height.unit || ""}
                >
                  <option value="cm">cm</option>
                  <option value="in">in</option>
                </select>
              </div>
            </div>
          </div>
        ))}

        <div className="flex justify-between gap-5 items-center px-5 py-2">
          <div className="flex gap-1 items-center">
            <div className="mx-[20px] mt- " onClick={handleAddMorePcsOfpackage}>
              <FaPlus className="text-[20px] text-[#03336E] " />
            </div>

            <div className="mx-[5px]  " onClick={handleRemovePcsOfpackage}>
              <FaMinus className="text-[20px] text-[#03336E] " />
            </div>
          </div>

          <div className="px-5 flex  items-center gap-5">
            <p className="text-[14px]"> Total Weight:</p>
            <p className="text-[14px] font-extrabold">
              {formData.totalWeight ? formData.totalWeight : totalWeight}
            </p>
          </div>
        </div>

        <div className="mx-[30px] flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal " htmlFor="country">
            Description<span className="text-[red] ">*</span>
          </label>
          <textarea
            placeholder="Description"
            className="w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
            name="description"
            id="description"
            onChange={handleInputChange}
            value={formData.description}
            maxLength={1000}
          />
        </div>

        <ServiceTemp
          formData={formData}
          setFormData={setFormData}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          templateSelected={templateSelected}
          setTemplateSelected={setTemplateSelected}
          attemptedSubmit={attemptedSubmit}
          isPopupOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
          areMandatoryFieldsFilled={areMandatoryFieldsFilled}
          areCurrenciesAligned={areCurrenciesAligned}
        />

        <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
          <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">

            <div className="flex items-center w-full lg:w-3/4 gap-1 py-2">
              <label className="w-full text-base font-medium">
                VAT Percentage :
              </label>
              <input
                type="number"
                className={`w-full p-2 text-sm border-2 rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.vatPercentage ? "border-red-500" : ""
                  }`}
                name="vatPercentage"
                id="vatPercentage"
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  if (
                    e.key === "e" ||
                    e.key === "-" ||
                    e.key === "+" ||
                    e.key === "E"
                  ) {
                    e.preventDefault();
                  }
                }}
                value={formData.vatPercentage || ""}
                min="0"
                step="1"
              />
            </div>
            {formData.vatPercentage < 0 && (
              <p className="text-red-500 text-sm">
                VAT Percentage must be greater than or equal to 0
              </p>
            )}
            {/* <InsuranceCheckbox formData={formData} setFormData={setFormData} /> */}
          </div>

          <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
            <div className="flex justify-between">
              <div>
                <p className="text-[14px]">Sub Total</p>
              </div>
              <div className="">
                <p className="text-[14px] font-extrabold">
                  {AmountFormat(formData.subTotal, formData.currency)}
                </p>
              </div>
            </div>

            <DiscountInput
              discountType={discountType}
              discountValue={discountValue}
              onDiscountTypeChange={setDiscountType}
              onDiscountValueChange={setDiscountValue}
              currency={formData.currency}
              discountAmount={formData.discount?.amount || 0}
            />

            {formData.discount && formData.discount.amount > 0 && (
              <div className="flex justify-between mt-1 text-orange-600">
                <div>
                  <p className="text-[14px] font-medium">
                    Discount ({formData.discount.type === 'percentage' ? `${formData.discount.value}%` : 'Fixed'})
                  </p>
                </div>
                <div>
                  <p className="text-[14px] font-extrabold">
                    - {AmountFormat(formData.discount.amount, formData.currency)}
                  </p>
                </div>
              </div>
            )}

            <div className="flex justify-between mt-1 ">
              <div>
                <p className="text-[14px]">Total VAT</p>
              </div>
              <div className="">
                <p className="text-[14px] font-extrabold ">
                  {AmountFormat(formData.vatAmount, formData.currency)}
                </p>
              </div>
            </div>

            <div className="flex justify-between mt-4 border-t border-cus-blue ">
              <div className="mt-2">
                <p className="text-[14px]">Total</p>
              </div>
              <div className="mt-2">
                <p className="text-[14px] font-extrabold ">
                  {AmountFormat(formData.total, formData.currency)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
        <div className="flex gap-2 items-center">
          <CustomButton
            label="Save and Send"
            onClick={handleAddData}
            loading={loading}
          />
          <CustomButton
            label="Save "
            onClick={handleDraft}
            loading={loading1}
          />
        </div>

        <PDFDownloadButton onClick={downloadPDF} loading={pdfLoading} />
      </div>
    </div>
  );
};

export default AddQuotesForExistUser;
